<template>
  <div class="hq_table_wrap">

    <div class="hq_container_theadfixed"
      v-if="fixed.thead">
      <div class="hq_table hq_table_theadfixed"
        :style="{width: real_tableWidth}">
        <div class="hq_thead hq_thead_theadfixed">
          <hqthead :sort="sort" :theadN="theadN"></hqthead>
        </div>
      </div>
    </div>

    <div class="hq_container_tablefixed"
      v-if="fixed.cols > 0">
      <div class="hq_table hq_table_tablefixed"
        :style="{width: real_tableWidth}"
        :hoverIndex="hoverIndex"
        :trHoverClass="trHoverClass">
        <div class="hq_thead hq_thead_tablefixed">
          <hqthead :sort="sort" :theadN="theadN"></hqthead>
        </div>  
      </div>
    </div>

    <div class="hq_container_colsfixed"
      v-if="fixed.cols > 0">
      <h-table 
        name="colsfixed"
        :sort="sort"
        :theadN="theadN"
        :tableWidth="real_tableWidth"
        :subset="subset"
        :indexList="sliceIndexList"
        :activeIndex="activeIndex"
        :dataMap="dataMap"
        :subsetIndexList="subsetIndexList"
		:virtualTopHeight="virtualTopHeight"
		:virtualBottomHeight="virtualBottomHeight"
        :hoverIndex="hoverIndex"
        :trHoverClass="trHoverClass">
          <template slot="extend" slot-scope="extend">
            <slot name="extend" :idx="extend.idx" :data="extend.data" :widths="columnWidths"></slot>
          </template>
          <template slot-scope="nodata" slot="nodata">
            <slot name="nodata" :container="{height: wrapH}"></slot>
          </template>
          <template v-slot:extend_tr="slotProps">
            <slot name="extend_tr" :idx="slotProps.idx" :data="slotProps.data" :widths="columnWidths"></slot>
          </template>
        </h-table>
    </div>
    
    
    <div class="hq_container_base">
	
      <h-table 
        name="base"
        :sort="sort"
        :theadN="theadN"
        :tableWidth="real_tableWidth"
        :subset="subset"
        :indexList="sliceIndexList"
        :activeIndex="activeIndex"
        :dataMap="dataMap"
		:virtualTopHeight="virtualTopHeight"
		:virtualBottomHeight="virtualBottomHeight"
        :subsetIndexList="subsetIndexList"
        :hoverIndex="hoverIndex"
        :trHoverClass="trHoverClass">
          <template slot="extend" slot-scope="extend" >
            <slot name="extend" :idx="extend.idx" :data="extend.data" :widths="columnWidths"></slot>
          </template>
          <template slot-scope="nodata" slot="nodata">
            <slot name="nodata" :container="{height: wrapH}"></slot>
          </template>
          <template v-slot:extend_tr="slotProps">
            <slot name="extend_tr" :idx="slotProps.idx" :data="slotProps.data" :widths="columnWidths"></slot>
          </template>
        </h-table>
    </div>
  </div>
</template>

<script>

import Util from './util'
import Formula from './formula'
import Hqthead from './thead.vue'
import HTable from './table.vue'
let REQUEST_KEY = ['55','ZQMC','zqmc']
export default {
  name: 'hqtable',
  props: {
    // 必传
    'data': {
      type: Array,
      required: true
    },
    'thead': {
      type: Array,
      required: true,
      // @remove can no send [key]
      // validator (arr) {
      //   let isok = true
      //   for (let i in arr) {
      //     if (!arr[i] || !arr[i].hasOwnProperty('key')){
      //       isok = false
      //       break
      //     }
      //   }
      //   return isok
      // }
    },
    // 非必传
    'subset': {
      type: Boolean,
      default: false
    },
    'codeKey': {
      type: String,
      default: 'code'
    },
    'indexKey': {
      type: String,
      default () {
        return this.codeKey
      }
    },
    'fixed': {
      type: Object,
      default () {
        return {
          thead:false,
          theadHeight:26,
          cols: 0,
          scrollWidth:17,
          scrollHeight:17
        }
      }
    },
    'tableWidth': {
      type: String,
      default: void 0
    },   
     'sort': {
      validator (obj) {
        return !obj || ( obj.hasOwnProperty('key') && obj.hasOwnProperty('type'))
      },
      default () {
        return {
          key: '',
          type: 'down'
        }
      }
    },
    'sortType': {
      validator (str) {
        return str === 'down' || str === 'up'
      },
      default: 'down'
    },
    'trHoverClass': {
      type: String
    },
	'virtualScroll': {
	  type: Object,
	  default () {
	    return {
		  lineHeight: 27,
		  showNumber: 0
		}
	  }
	},
	'formulaExtend': {
	  type: Object,
	  default () {
	    return {}
	  }
	}
  },
  data () {
    return {
      quoteTypes: [],
      theadN: void 0,
      indexList: [], // index
      dataMap: {}, // index -> data
      subsetIndexList: {}, // index -> subsetIndexList, for sort
      activeIndex: void 0,
      hoverIndex: void 0,
      columnWidths: [],
      wrapH: 0,
      formula: Formula,
      real_tableWidth: '100%',
	  virtualTopHeight: 0,
	  virtualBottomHeight: 0,
	  sliceIndexList: []
    }
  },
  watch: {
    'data' () {
      this.whenData()
    },
	'indexList' () {
	  this.setVirtualHeight()
	}
  },
  created () {
    this.formula = Object.assign(this.formulaExtend,this.formula)

  },
  computed: {
    
  },
  mounted () {
    const s = this

    s.whenThead(true)
    s.whenData()

    if (s.fixed.thead || s.fixed.cols > 0) {
      this.$el.querySelector('.hq_container_base').addEventListener('scroll', this.handleScroll)
	 
    }else{
	  this.$el.querySelector('.hq_container_base').addEventListener('scroll', ()=>{
		this.setVirtualHeight(this.$el.querySelector('.hq_container_base'))
	  })
	}
	
    if (s.fixed.cols > 0) {
      this.$el.querySelector('.hq_container_colsfixed').onmousewheel = s.handleColsFixedMouseEvent
    }

    s.resize()

    // register tr event
    if (s.$listeners && s.$listeners['on-scroll-y']) {
      s.$el.querySelector('.hq_container_base').addEventListener('scroll', e => {
        s.$emit('on-scroll-y', e, {
          container: {height: s.wrapH, innerHeight: s.$el.querySelector('.hq_table_base').offsetHeight},
          scrollTop: e.target.scrollTop
        })
      })
    }
    if (s.$listeners && s.$listeners['on-row-click']) {
      Util.on('click', s.$el, function (target) {
        return (target.className + ' ').match(/hq_tr\s|hq_tr_subset\s/) && target.getAttribute('idx')
      }, function(e, target) {
        let idx = target.getAttribute('idx')
        s.$emit('on-row-click', e, s.dataMap[idx], target)
      })
    }

  },
  destoryed () {
    const s = this
    (s.fixed.thead || s.fixed.cols > 0) && this.$el.querySelector('.hq_container_base').removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    addHover(){
      const s = this
	  
	  Array.from(s.$el.querySelectorAll('.hq_table .hq_tr')).forEach((item,index)=>{
	    if(Util.hasClass(item.className,s.trHoverClass)){
		  item.className = Util.removeClass(item.className,s.trHoverClass)
		}
	    
		item.onmouseenter = (e) => {
		  const idx = item.getAttribute('idx')
		  Array.from(s.$el.querySelectorAll('.hq_table .hq_tr[idx="'+idx+'"]')).forEach((item2,index)=>{
		  item2.className = Util.addClass(item2.className,s.trHoverClass)
		  })
		}

		item.onmouseleave = (e) => {
		  Array.from(s.$el.querySelectorAll('.hq_table .hq_tr[idx="'+item.getAttribute('idx')+'"]')).forEach((item2,index)=>{
			item2.className = Util.removeClass(item2.className,s.trHoverClass)
		  })
		}
	  })
	},
    getFormula (f, name) {
      const s = this
      if (!f) return
      f = Array.isArray(f) ? f : [f]
      for (let item of f) {
        if (s.formula[item] && s.formula[item][name]) {
          return s.formula[item][name]
        }
      }
      return
    },
    addFormula (name, data) {
      const s = this
      if (!name) return
      s.formula[name] = data
      s.whenThead()
    },
    handleColsFixedMouseEvent (e) {
      e = e || window.e
      let baseWrap = this.$el.querySelector('.hq_container_base')
      let colsFixedWrap = this.$el.querySelector('.hq_container_colsfixed')
      if (!colsFixedWrap) return

      let top = baseWrap.scrollTop
      let maxTop = baseWrap.scrollHeight - baseWrap.clientHeight
      if (e.deltaY > 0) {
        top += 40
      } else {
        top -= 40
      }
      top = top > maxTop ? maxTop : top // @FIX colsFixedWrap's height > base table height,scrolltop unqual
      colsFixedWrap.scrollTop = baseWrap.scrollTop = top
    },
    handleScroll (e) {
	
      let baseWrap = this.$el.querySelector('.hq_container_base')
      let theadFixedWrap = this.$el.querySelector('.hq_container_theadfixed')
      let colsFixedWrap = this.$el.querySelector('.hq_container_colsfixed')
      if (theadFixedWrap) {
        theadFixedWrap.scrollLeft = baseWrap.scrollLeft
      }
      if (colsFixedWrap) {
        colsFixedWrap.scrollTop = baseWrap.scrollTop
      }
	  
	  //add virtual scroll 
	  this.setVirtualHeight(baseWrap)
	  
    },
	setVirtualHeight (baseWrap) {
	  if (this.virtualScroll.showNumber && this.data && this.data.length) {
	    
	    if(!baseWrap){
		   baseWrap = {scrollTop : 0}
		}
		
	    let start = parseInt(baseWrap.scrollTop/this.virtualScroll.lineHeight) 
		if(this.indexList.length - start <= this.virtualScroll.showNumber) {
		  start = this.indexList.length - this.virtualScroll.showNumber <= 0 ? 0 : this.indexList.length - this.virtualScroll.showNumber
		}
		this.sliceIndexList = this.indexList.slice(start,this.virtualScroll.showNumber + start)
		this.virtualTopHeight = start * this.virtualScroll.lineHeight + 'px'
		let remainNumber = this.data.length - start - this.virtualScroll.showNumber
		remainNumber = remainNumber < 0 ? 0 : remainNumber
		
		this.virtualBottomHeight = remainNumber * this.virtualScroll.lineHeight + 'px'
	
	  }else{
		this.sliceIndexList = this.indexList;
	  }

	},
    setActiveIndex (idx) {
      this.activeIndex = idx
    },
    getActiveIndex (idx) {
      return this.activeIndex
    },
    setSubState (idx, toggle) {
      const s = this
      if (!s.subset || !s.dataMap[idx].subset || !s.dataMap[idx].subset.length) return

      s.dataMap[idx].subState = toggle!== undefined ? toggle : !s.dataMap[idx].subState
      s.$forceUpdate()
    },
    // when (click) th-sort
    handleSort (th) {
      const s = this
      if (s.$listeners && s.$listeners['on-th-click']) {
        s.$emit('on-th-click', th)
      }
      if (!th.sort) return
      s.sort.type = s.sort.key === th.key ? s.reverseSortType(s.sort.type) : th.sortType
      s.sort.key = th.key
	  
	  s.sortData(s.sort.key, s.sort.type)
	  
	  this.$el.querySelector('.hq_container_base').scrollTop = 0
	  
    },
    getThead : function(key){
      const s = this

      for(let i in s.theadN) {
        if(s.theadN[i].key === key) {
          return s.theadN[i]
        }
      }

      Util.Warning('can not find thead of [key=' + key + '].')
      return
    },
    // sort [data]
    sortData (key, type) {
      const s = this

      let thead = s.getThead(key)
      let indexList = s.indexList.concat()
      let subsetIndexList = s.subsetIndexList
      
      if (!thead) return

      let handleSort = function (a, b) {
        let aPos, bPos
        if (a.v && b.v) {
          aPos = a.i
          bPos = b.i
          a = a.v
          b = b.v
        }
        // if this data is = ， return the o pos
        if (JSON.stringify(s.dataMap[a][key]) === JSON.stringify(s.dataMap[b][key])) {
          return aPos - bPos
        }
        if (typeof thead.sort === 'function') {
          return thead.sort(s.dataMap[a][key], s.dataMap[b][key], type)
        }
        
        if (!Util.isNum(s.dataMap[a][key])) { return 1; }
        if (!Util.isNum(s.dataMap[b][key])) { return -1; }
        a = s.dataMap[a][key] - 0
        b = s.dataMap[b][key] - 0


        if (a > b) {
          return type === 'down' ? -1 : 1
        } else if (a == b) {
          return 0
        } else {
          return type === 'down' ? 1 : -1
        }
      }

      // record pos
      indexList = Util.stableSort(indexList, handleSort)
      s.indexList = indexList

      // subset
      if (!s.subset) return
      for (let idx in subsetIndexList) {
        // record pos
        subsetIndexList[idx] = Util.stableSort(subsetIndexList[idx], handleSort)
      }
      s.subsetIndexList = subsetIndexList
    },
    setData (data) {
      const s = this
      let indexList = []
      let dataMap = s.dataMap
      let subsetIndexList =  {} // index -> subset index list . for sort
      for(var i in s.data) {
        // obj arr
        if (typeof data[i] === 'object') {
          if (!data[i][s.indexKey]) continue
          let idx = data[i][s.indexKey]
          indexList.push(idx)
          dataMap[idx] = data[i]
          dataMap[idx].subState = dataMap[idx].subState || false
          dataMap[idx].isSub = false
          subsetIndexList[idx] = []
          for (let j in data[i]['subset']) {
            let subIdx = data[i]['subset'][j][s.indexKey]
            dataMap[subIdx] = data[i]['subset'][j]
            dataMap[subIdx].isSub = true
            subsetIndexList[idx].push(subIdx)
          }
        } 
        // index arr
        else { 
          let idx = data[i]
          indexList.push(idx)
          dataMap[idx] = {}
          dataMap[idx][s.indexKey] = idx
        }
      }
      s.indexList = indexList
      s.dataMap = dataMap
      s.subsetIndexList = subsetIndexList

      s.requestQuote()
      s.$nextTick(function(){
        s.resize()
      })
    },
    // when [data] change
    whenData () {
      const s = this
      s.dataMap = {} // index -> data
      s.setData(s.data)
	  
	  this.$nextTick(()=>{
	    this.addHover()
	  })
    },
    // then [thead] change,  once (@Notice event register here)
    whenThead (isFirst) {
      const s = this
      let thead = JSON.parse(JSON.stringify(s.thead)) //! function will loss
      for (let i in thead) {
        let t = thead[i]

        t.name = t.name || s.getFormula(t.formula, 'name') || ''
        t.key = t.key || s.getFormula(t.formula, 'key')

        t.events = s.thead[i].events || null;

        t.sort = t.sort || void 0;
        t.sortType = t.sortType || s.sortType;

        t.fromQuote = !!((t.fromQuote + 1 || s.getFormula(t.formula, 'fromQuote') + 1) - 1)
        t.fromQuote && s.quoteTypes.push(t.key)

        t.format = s.thead[i].format || s.getFormula(t.formula, 'format') || function (v) {return v}
        t.class = Array.isArray(t.class) ? t.class.join(' ') : (t.class || '')

        if (isFirst && t.events) {
          for (let event in t.events) {
            Util.on(event, s.$el, function (target) {
              return (target.className + ' ').match(/hq_td\s|hq_td_subset\s/) && target.getAttribute('td-key') == t.key
            }, function(e, target) {
              let idx = target.parentElement.getAttribute('idx')
              t.events[event].call(s, e, s.dataMap[idx], target)
            })
          }
        }
        
      }
      s.theadN = thead
    },
    requestQuote (cb) {
      const s = this
      let indexList = s.indexList

      let getData = function () {
        window.API.use({
          method: 'Quote.getData2',
          data: {
            type: s.quoteTypes,
            code: s.getCodeList(indexList),
            period: 'now'
          },
          success: function(d){
            try{
              let dataMap = s.dataMap
              d = JSON.parse(d)
              for (let i in indexList) {
                let idx = indexList[i]
                let code = dataMap[idx][s.codeKey]
                dataMap[idx] = Util.extend(dataMap[idx], d.hasOwnProperty(code) ? d[code] : {})
                // subset
                for (let j in s.subsetIndexList[idx]) {
                  let subIdx = s.subsetIndexList[idx][j]
                  let subCode = dataMap[subIdx][s.codeKey]
                  dataMap[subIdx] = Util.extend(dataMap[subIdx], d.hasOwnProperty(subCode) ? d[subCode] : {})
                }
              }
              s.dataMap = dataMap
              s.$forceUpdate()
              cb && cb()
            } catch(e) {}
          },
          notClient: function () {
            cb && cb()
          }
        })
      }

      let codelist = s.getCodeList(indexList)
      if (!codelist || !codelist.length) return

      if (s.onlyNeedRequest(s.quoteTypes)) {
        getData()
      } else {
        window.API.use({
          method: 'Quote.request',
          data: {
            type: s.quoteTypes,
            code: codelist,
            period: 'now'
          },
          callbackName: 'onready',
          success: function(){
            getData();
          },
          notClient: function(){
            cb && cb()
          }
        })
      }
    },
    onlyNeedRequest (list) {
      var i, j , f;
      for(i=0; i<list.length; i++) {
        f = false;
        for(j=0; j<REQUEST_KEY.length; j++) {
          if( list[i] === REQUEST_KEY[j] ) {
            f = true;
            break;
          }
        }
        if(!f) {
          return false;
        }
      }
      return true;
    },
    getCodeList (indexList) {
      var s = this;
      var codeList = []
      for(var i=0;i<indexList.length;i++) {
        codeList.push(s.dataMap[indexList[i]][s.codeKey])
        // subset
        for (let j in s.dataMap[indexList[i]]['subset']) {
          codeList.push(s.dataMap[indexList[i]]['subset'][j][s.codeKey])
        }
      }
      return codeList
    },
    // reverse sortType
    reverseSortType (type) {
      if(type === 'up') {
        return 'down';
      }else {
        return 'up';
      }
    },
    resize () {
	
      const s = this

      s.wrapH = s.$el.clientHeight
      let baseTable = s.$el.querySelector('.hq_table_base')
      let fixedheadTable = s.$el.querySelector('.hq_table_theadfixed')
      let fixedTableTable = s.$el.querySelector('.hq_table_tablefixed')
      let fixedColsTable = s.$el.querySelector('.hq_table_colsfixed')

      let baseWrap = s.$el.querySelector('.hq_container_base')
      let fixedTheadWrap = s.$el.querySelector('.hq_container_theadfixed')
      let fixedTableWrap = s.$el.querySelector('.hq_container_tablefixed')
      let fixedColsWrap = s.$el.querySelector('.hq_container_colsfixed')
      let fixedColsThead = s.$el.querySelector('.hq_thead_colsfixed')
      let fixedColsTbody = s.$el.querySelector('.hq_tbody_colsfixed')
      let fixedTableThead = s.$el.querySelector('.hq_thead_tablefixed')
      let columnWidths = [] // record every column's width

      // let w = baseTable.offsetWidth
      let w2 = s.$el.offsetWidth
      let h = s.$el.offsetHeight
      let haveScrollH = baseTable.offsetHeight > baseWrap.offsetHeight
      let fixedW = w2 - (haveScrollH ? s.fixed.scrollWidth : 0)  + 'px'
      fixedTheadWrap && (fixedTheadWrap.style.width = fixedW)
      fixedColsThead && (fixedColsThead.style.width = fixedW)
      fixedColsTbody && (fixedColsTbody.style.width = fixedW)
      fixedTableThead && (fixedTableThead.style.width = fixedW)
      

      let tbase = baseTable.querySelectorAll('.hq_thead .hq_th')
      let w3 = 0
      for (let i=0; i<tbase.length; i++) {
        columnWidths[i] = tbase[i].clientWidth
        w3 += columnWidths[i]
      }
      s.columnWidths = columnWidths

      // if (s.fixed.thead) {
      //   let tbase = baseTable.querySelectorAll('thead th')
      //   let tfh = fixedheadTable.querySelectorAll('thead th')
      //   for (let i=0; i<tfh.length; i++) {
      //     let tmpW = tbase[i].offsetWidth
      //     tfh[i] && (tfh[i].style.width = tmpW + 'px')
      //   }
      // }

      if (s.fixed.cols > 0) {
        let fixColsWid = 0
        let tbase = baseTable.querySelectorAll('.hq_thead .hq_th')
        for (let i=0; i<tbase.length; i++) {
          let tmpW = tbase[i].clientWidth
          if (i < s.fixed.cols) {
            fixColsWid += tmpW
          }
        }
        
        let tmpH = w3 <= w2 ? h : h - s.fixed.scrollHeight
        s.real_tableWidth = s.tableWidth || w3 <= w2 ? '100%' : w3 + 'px'
        fixedTableWrap.style.width = fixColsWid + 'px'
        fixedColsWrap.style.height = tmpH + 'px'
        fixedColsWrap.style.width = fixColsWid + 'px'
        // baseWrap.style.top = -tmpH - s.fixed.theadHeight - (s.fixed.thead ? s.fixed.theadHeight : 0) + 'px'
      }

    }
  },
  components: {
    Hqthead,
    HTable
  }
}
</script>

<style>
  .hq_table_wrap {
    overflow: hidden;
    position: relative;
  }
  .hq_container_base {
    width:  100%;
    z-index:1;
    position:absolute;
    height:100%;
    overflow:auto;
    top: 0;
    left: 0;
  }
  .hq_container_theadfixed {
    z-index:2;
    position:absolute;
    overflow:hidden;
    top: 0;
    left: 0;
  }
  .hq_container_tablefixed {
    z-index:4;
    position:absolute;
    overflow:hidden;
    top: 0;
    left: 0;
  }
  .hq_container_colsfixed {
    z-index:3;
    position:absolute;
    overflow:hidden;
    top: 0;
    left: 0;
  }
  .hq_table {
    position: relative;
  }
  .hq_tbody,
  .hq_thead {
  }
  .hq_td,
  .hq_td_subset,
  .hq_th {
    flex: 1 0 auto;
    text-align: center;
    cursor: default;
  }
  .hq_tr,
  .hq_tr_subset{
    display: flex;
    position: relative;
   /* flex-direction: row; */
   /* justify-content: center; */
   /* align-items: center; */
  }

</style>


// WEBPACK FOOTER //
// src/lib/v-hqtable/lib/HqTable.vue